// link reference: https://github.com/webpack/webpack/issues/2427#issuecomment-342428107
module.exports = {
    BASE_URL: process.env.REACT_BASE_URL
}